import React from 'react'

import { Switch, Route } from 'react-router-dom'

// Unauthenticated Pages Here
import UnauthenticatedForgotPasswordIndex from './ForgotPassword/UnauthenticatedForgotPasswordIndex'
import UnauthenticatedLoginIndex from './Login/UnauthenticatedLoginIndex'
import UnauthenticatedOnboardingIndex from './Onboarding/OnboardingIndex'
import UnauthenticatedResetPasswordIndex from './ResetPassword/UnauthenticatedResetPasswordIndex'
import UnauthenticatedSignupIndex from './Signup/UnauthenticatedSignupIndex'
import UnauthenticatedPageNotFound from './UnauthenticatedPageNotFound'
import UnauthenticatedWelcomeIndex from './Welcome/UnauthenticatedWelcomeIndex'

const UnauthenticatedRoutes = () => (
  <Switch>
    <Route exact path="/signup" component={UnauthenticatedSignupIndex} />
    <Route
      exact
      path="/forgot-password"
      component={UnauthenticatedForgotPasswordIndex}
    />
    <Route
      exact
      path="/reset-password"
      component={UnauthenticatedResetPasswordIndex}
    />
    <Route
      exact
      path="/onboarding"
      component={UnauthenticatedOnboardingIndex}
    />
    <Route exact path="/welcome" component={UnauthenticatedWelcomeIndex} />
    <Route component={UnauthenticatedLoginIndex} />
    <Route component={UnauthenticatedPageNotFound} />
  </Switch>
)

UnauthenticatedRoutes.propTypes = {}

export default UnauthenticatedRoutes



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/UnauthenticatedRoutes.js